import axios from 'axios';

const getSettings = () => axios.get('/live-chat/settings');

const updateSettings = newSettings => {
  return axios.put('/live-chat/settings', newSettings);
};

export { getSettings, updateSettings };
